import {Feature} from '@webmate-web-core/shared/types/feature';

export enum ToolbarPluginType {
    FULLSCREEN,

    KEYBOARD_LAYOUT,
    FIT_TO_GUEST,
    TOGGLE_RELATIVE_PAD,
    CTRL_ALT_DELETE,
    CLIPBOARD,

    SPECIAL_KEYS,

    GPS,
    ROTATION,
    WAKEUP,
    IMAGE_QUALITY,
    BIOMETRICS,
    CAMERA_SIMULATION,
    VIDEO_RECORDING,
    GALLERY,

    IOS_METRICS,

    ALLOW_JOBS,
    LIMIT_BANDWIDTH,
    INSTALL_APP,
    SHOW_CAPABILITIES,
    REPORT_MALFUNCTION,

    INFO,
    STATUS_ICONS,
    TEST,
    DEVICE_DETAILS,
    TESTMAILS,
    LOG,
    DEBUGGING_VM,
    DEVICE_SCREENSHOT,

    AUDIO_STREAMING,
    SCREEN_READER,

    DEFAULT_INTERACTION_MODE,
    CONTROLLER_INTERACTION_MODE,

    HARDWARE_SCAN_BUTTON,
}

export interface ToolbarPlugin {
    type: ToolbarPluginType;
    callback: Function;
    toggleable: boolean;
    optCallbacks?: Array<Function>;
    featureGuard?: FeatureGuard;
    payload?: any;
    resizable?: boolean;
    optMinWidth?: number;
    optMinHeight?: number;
    wontToggleOnStart?: boolean;
}

export interface FeatureGuard {
    feature: string;

    check?(feature: Feature): boolean;
}

export interface ToolbarPluginEvent {
    p: ToolbarPlugin;
    type: string;
    value: any;
}

export const ToolbarPluginToggledEvent = 'plugin.toggled';
